import { createI18n } from "vue-i18n";
import ko from "./locales/ko.json";
import en from "./locales/en.json";

// 다국어 메시지 정의
const messages = { en, ko };

// ✅ Composition API 모드 활성화 (`legacy: false` 추가)
const i18n = createI18n({
  legacy: false, // ✅ Composition API 모드 활성화 (옵션 API 비활성화)
  locale: "ko", // 기본 언어
  fallbackLocale: "en", // 언어 설정이 없을 때 사용할 기본 언어
  messages,
});

export default i18n;
